var _CustomComparer_comparer, _CustomComparer_equalityComparer;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import ArgumentException from '../Exceptions/ArgumentException';
import ArgumentUndefinedException from '../Exceptions/ArgumentUndefinedException';
import isUndefinedOrNull from '../TypeHelpers/isUndefinedOrNull';
export default class CustomComparer {
    constructor(comparer, equalityComparer) {
        _CustomComparer_comparer.set(this, void 0);
        _CustomComparer_equalityComparer.set(this, void 0);
        if (isUndefinedOrNull(comparer) && isUndefinedOrNull(equalityComparer)) {
            throw new ArgumentException("You must provide at least one argument.");
        }
        __classPrivateFieldSet(this, _CustomComparer_comparer, comparer, "f");
        __classPrivateFieldSet(this, _CustomComparer_equalityComparer, equalityComparer, "f");
    }
    compare(x, y) {
        if (__classPrivateFieldGet(this, _CustomComparer_comparer, "f")) {
            return __classPrivateFieldGet(this, _CustomComparer_comparer, "f").call(this, x, y);
        }
        else {
            throw new ArgumentUndefinedException("you must specify the comparer in the constructor to use compare.");
        }
    }
    equals(x, y) {
        if (__classPrivateFieldGet(this, _CustomComparer_equalityComparer, "f")) {
            return __classPrivateFieldGet(this, _CustomComparer_equalityComparer, "f").call(this, x, y);
        }
        else {
            throw new ArgumentUndefinedException("you must specify The equality comparer in the constructor to use equals.");
        }
    }
    greaterThan(x, y) {
        return this.compare(x, y) > 0;
    }
    greaterThanOrEqual(x, y) {
        return this.compare(x, y) >= 0;
    }
    lessThan(x, y) {
        return this.compare(x, y) < 0;
    }
    lessThanOrEqual(x, y) {
        return this.compare(x, y) <= 0;
    }
}
_CustomComparer_comparer = new WeakMap(), _CustomComparer_equalityComparer = new WeakMap();
